import React from 'react';
import PostForm from '../../../components/post/post-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as postActions from '../../../actions/post';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';

class PartnerContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/posts';
    }

    fetchItem(id) {
        return this.props.actions.fetchPost(id)
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.postEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <PostForm submit={actions.submitPost} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></PostForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.post.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...postActions
        }, dispatch)
    };
})(PartnerContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/post/post-container.js